export const autmationColumns = [
  { id: 'member', label: 'Member', sortable: false },
  { id: 'status', label: 'Plan item status', sortable: false },
  { id: 'assignedDate', label: 'Date', sortable: false },
];
